import { useSelector } from 'react-redux';
import { CurrencyItemWithSkeleton } from '../../../../components/Skeletons/ItemsWithSkeleton';
import { createRootModal } from '../../RootModal';
import './ModalCurrencyList.scss';

const ModalCurrencyList = createRootModal(() => {
	const { items } = useSelector(state => state.app.modals).find(i => i.tag === 'ModalCurrencyList').outsideParams;

	console.log('items', items);

	return (
		<div className='ModalCurrencyList'>
			<div className='FormBlock'>
				<CurrencyItemWithSkeleton items={items} />
			</div>
		</div>
	);
});

export default ModalCurrencyList;
